// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"b51ca53b","392":"5582fe7d","426":"948580b7","491":"83a3c9d5","622":"c353e859","840":"faebabce","976":"d1ba5a8a"}[chunkId] + ".chunk.css";
};